export const themeColors = [
  {
    lightBackground: 'bg-theme-1-100',
    background: 'bg-theme-1-200',
    darkBackground: 'bg-theme-1-300',
    lightBorder: 'border-theme-1-100',
    border: 'border-theme-1-300',
    text: 'text-theme-1-300',
    hover: 'hover:bg-theme-1-50 hover:text-theme-1-300',
    outline: 'outline-theme-1-300',
  },
  {
    lightBackground: 'bg-theme-2-100',
    background: 'bg-theme-2-200',
    darkBackground: 'bg-theme-2-300',
    lightBorder: 'border-theme-2-100',
    border: 'border-theme-2-300',
    text: 'text-theme-2-300',
    hover: 'hover:bg-theme-2-50 hover:text-theme-2-300',
    outline: 'outline-theme-2-300',
  },
  {
    lightBackground: 'bg-theme-3-100',
    background: 'bg-theme-3-200',
    darkBackground: 'bg-theme-3-300',
    lightBorder: 'border-theme-3-100',
    border: 'border-theme-3-300',
    text: 'text-theme-3-300',
    hover: 'hover:bg-theme-3-50 hover:text-theme-3-300',
    outline: 'outline-theme-3-300',
  },
  {
    lightBackground: 'bg-theme-4-100',
    background: 'bg-theme-4-200',
    darkBackground: 'bg-theme-4-300',
    lightBorder: 'border-theme-4-100',
    border: 'border-theme-4-300',
    text: 'text-theme-4-300',
    hover: 'hover:bg-theme-4-50 hover:text-theme-4-300',
    outline: 'outline-theme-4-300',
  },
  {
    lightBackground: 'bg-theme-5-100',
    background: 'bg-theme-5-200',
    darkBackground: 'bg-theme-5-300',
    lightBorder: 'border-theme-5-100',
    border: 'border-theme-5-300',
    text: 'text-theme-5-300',
    hover: 'hover:bg-theme-5-50 hover:text-theme-5-300',
    outline: 'outline-theme-5-300',
  },
  {
    lightBackground: 'bg-theme-6-100',
    background: 'bg-theme-6-200',
    darkBackground: 'bg-theme-6-300',
    lightBorder: 'border-theme-6-100',
    border: 'border-theme-6-300',
    text: 'text-theme-6-300',
    hover: 'hover:bg-theme-6-50 hover:text-theme-6-300',
    outline: 'outline-theme-6-300',
  },
  {
    lightBackground: 'bg-theme-7-100',
    background: 'bg-theme-7-200',
    darkBackground: 'bg-theme-7-300',
    lightBorder: 'border-theme-7-100',
    border: 'border-theme-7-300',
    text: 'text-theme-7-300',
    hover: 'hover:bg-theme-7-50 hover:text-theme-7-300',
    outline: 'outline-theme-7-300',
  },
  {
    lightBackground: 'bg-theme-8-100',
    background: 'bg-theme-8-200',
    darkBackground: 'bg-theme-8-300',
    lightBorder: 'border-theme-8-100',
    border: 'border-theme-8-300',
    text: 'text-theme-8-300',
    hover: 'hover:bg-theme-8-50 hover:text-theme-8-300',
    outline: 'outline-theme-8-300',
  },
];
